import React from 'react';

const Modal = ({ open, onClose, children }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-md">
      <div className="rounded-2xl shadow-lg p-6 md:p-8 max-w-lg w-full relative bg-white/20">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-500 hover:text-white text-3xl font-bold"
          aria-label="Close"
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
